import { render, staticRenderFns } from "./privilege.vue?vue&type=template&id=93169a7e&scoped=true&"
import script from "./privilege.vue?vue&type=script&lang=js&"
export * from "./privilege.vue?vue&type=script&lang=js&"
import style0 from "./privilege.vue?vue&type=style&index=0&id=93169a7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93169a7e",
  null
  
)

export default component.exports